<template>
    <div class="partyBuildGarden">
        <div class="policiesBox">
            <div class="policiesHead">
                <div>
                    <span class="title">党建园地</span>
                    <span class="describe">党建园地，党性传承</span>
                </div>
                <div class="more" @click="onMore()">更多 +</div>
            </div>
            <div class="policiesContent">
                <div  v-for="(item, index) in partyBuildings"  :key="index">
                    <div class="notificationBox"  >
                        <div class="dot"></div>
                        <div :class="['Title', selectedRow == index ? 'selectRow'  : '']" @click="onJumpLink(item, index)">{{item.title}}</div>
                        <div class="time">
                            {{item.createDate}}
                        </div>
                    </div>
                </div>
            </div>


            
        </div>

        <div class="joinAssociation">
            <div class="joinAssociationHead">
                <span class="title">加入协会</span>
                <span class="describe">同心聚力，携手并进</span>
            </div>

            <el-row :gutter="16" style="width:100%;margin-top: 10px;" >
                    <el-col :span="12" v-for="(item, index) in aboutUsInfos" :key="index" 
                    style="margin-bottom: 16px;">
                        <!-- <div class="contentBoxTwo" v-if="item.title=='会员义务'" @click="onLink(item)">
                            <div class="contentBoxLayout">
                                <div class="boxLeftLayout"">
                                    <img src="../../assets/img/newHome/membershipObligation.png" style="width: 30px;"/>
                                    <div style="font-weight: bold;font-size: 16px;color: #fff;margin-top: 16px;">{{ item.title }}</div>
                                    <div style="font-size: 14px;color: #ffff;margin-top: 8px;">{{ item.createDate }}</div>
                                    
                                    
                                </div>
                                <div>
                                    <img src="../../assets/img/newHome/uploadLogoTwo.png" style="margin-top:75px ;width: 20px;"/>
                                </div>
                            </div>
                        </div> -->
                        <div class="contentBox"  @click="onLink(item)"  @mouseover="hoverIndex = index" @mouseleave="hoverIndex = null">
                                    <el-row>
                                        <el-col :span="7" style="text-align: center;">
                                            <img v-if="item.title=='协会服务'" :src="hoverIndex == index ? require('../../assets/img/newHome/associationServiceWhite.png') : require('../../assets/img/newHome/associationService.png')"  style="width: 30px;margin-top:30px ;"/>
                                            <img v-if="item.title=='申请表格'" :src="hoverIndex == index ? require('../../assets/img/newHome/sheetWhite.png') : require('../../assets/img/newHome/sheetGreen.png')"  style="width: 30px;margin-top:30px ;"/>
                                            <img v-if="item.title=='入会流程'" :src="hoverIndex == index ? require('../../assets/img/newHome/flowWhite.png') : require('../../assets/img/newHome/flowGreen.png')"  style="width: 30px;margin-top:30px ;"/>
                                            <img v-if="item.title=='会员义务'" :src="hoverIndex == index ? require('../../assets/img/newHome/membershipObligation.png') : require('../../assets/img/newHome/membershipObligationTwo.png')"  style="width: 30px;margin-top:30px ;"/>
                                        </el-col>
                                        <el-col :span="10" style="text-align: center;">
                                            <div v-if="hoverIndex == index" style="font-weight: bold;font-size: 16px;color: #ffffff;margin-top: 35px;">{{ item.title }}</div>
                                            <div v-else style="font-weight: bold;font-size: 16px;color: #000000;margin-top: 35px;">{{ item.title }}</div>    
                                        </el-col>
                                        <el-col :span="7" style="text-align: center;">
                                            <img src="../../assets/img/newHome/uploadLogoTwo.png" style="margin-top:35px ;width: 20px;"/>
                                        </el-col>
                                    </el-row>
                        </div>
                    </el-col>

                </el-row>

            <!-- <div class="contentTop">
                <div class="contentTopLeft" >
                    协会服务
                </div>

                <div class="contentTopRight" >
                   
                </div>
            </div>


            <div class="contentBottom">
                <div class="contentBottomLeft" >
                    
                </div>

                <div class="contentBottomRight" >
                    
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import * as dayjs from 'dayjs';
import { prefixedUrlAsset } from '@/utils/constants';
export default {
    props: {
        partyBuildings: {
            type: Array,
            default: () => {}
        },
        aboutUsInfos: {
            type: Array,
            default: () => {}
        },
    },
    components: {},
    computed: {
    
    },
    data() {
        return {
            selectedIndex: 0,
            dynamicList:[],
            informList:[],
            industryInfoList:[],
            selectedRow: null,
            hover: false,
            hoverIndex: null,      
        };
    },
 
    created() {
    },
    mounted() {
    },
    methods: {
        onJumpLink(item, index){
            this.selectedRow=index
            window.open(`/#/detail/`+item.id);
        },
        onLink(item){
            window.open(`/#/detail/`+item.id);
        },
        onMore(){
            window.open(`/#/list/7/党建园地`);
        }
        
        
    },
};
</script>

<style lang="less">
    .partyBuildGarden{
        padding:10px 10% 20px 10%;
        display: flex;
        background: #F5F5F5;
        .policiesBox{
            width: 50%;
            margin-right: 20px;
            background: #fff;
            padding: 16px;
            .policiesHead{
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 2px solid #E4E7ED;
                padding-bottom: 3px;
                .title{
                    font-weight: bold;
                    font-size: 24px;
                    color: #000000;
                    border-bottom: 4px solid #00A287;
                }
                .describe{
                    font-weight: bold;
                    font-size: 16px;
                    color: #00A287;
                    margin-left: 16px;
                }
                .more{
                    font-size: 14px;
                    color: #9AA6B5;
                    cursor: pointer;
                    &:hover {
                        color: #00A287;
                        font-weight: bold;
                    }
                }
            }
            .policiesContent{
                margin-top: 10px;
                .notificationBox{
                    display: flex;
                    align-items: center;
                    justify-content:space-between; 
                    padding: 5px 0; 
                    .dot{
                        width: 8px;
                        height: 8px;
                        background: #0BA58C;
                        border-radius: 50%;
                    }      
                    .Title{
                        margin-left: 16px;
                        flex: 1;
                        display: -webkit-box;
                        word-break: break-all;             
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        font-size: 14px;
                        color: #000000;
                        cursor: pointer;
                        &:hover {
                            color: #00A287;
                        }
                    }
                    .time{
                        width: 100px;
                        margin-left: 10px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9AA6B5;
                        text-align: right;
                    }
                    .selectRow{
                        color: #00A287
                    }

                }
            }
            
            
        }

        .joinAssociation{
            width: 50%;
            background: #fff;
            padding: 16px;
            .joinAssociationHead{
                align-items: center;
                border-bottom: 2px solid #E4E7ED;
                padding-bottom: 3px;
                .title{
                    font-weight: bold;
                    font-size: 24px;
                    color: #000000;
                    border-bottom: 4px solid #00A287;
                }
                .describe{
                    font-weight: bold;
                    font-size: 16px;
                    color: #00A287;
                    margin-left: 16px;
                }
            }
            .contentBox{
                width: 100%;
                height: 100px;
                background: linear-gradient( 153deg, #CCECE7 0%, #FFFFFF 100%);
                border-radius: 16px 16px 16px 16px;
                cursor: pointer;
                &:hover {
                    background: linear-gradient( 137deg, #13A88F 0%, rgba(19,168,143,0.2) 100%);
                }
                .contentBoxLayout{
                    display: flex;
                    justify-content: space-between;
                    padding: 0px 32px;
                    .boxLeftLayout{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: start;
                        flex-direction: row;
                    }
                }
            }
            .contentBoxTwo{
                width: 100%;
                height: 150px;
                background: linear-gradient( 137deg, #13A88F 0%, rgba(19,168,143,0.2) 100%);
                border-radius: 16px 16px 16px 16px;
                cursor: pointer;
                .contentBoxLayout{
                    display: flex;
                    justify-content: space-between;
                    padding: 25px 32px;
                    .boxLeftLayout{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: start;
                    }
                }
            }
            .contentTop{
                display: flex;
                margin-top: 46px;
                .contentTopLeft{
                    width: 50%;
                    height: 160px;
                    margin-right: 16px;
                    background: linear-gradient( 153deg, #CCECE7 0%, #FFFFFF 100%);
                    border-radius: 16px 16px 16px 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    
                }
                .contentTopRight{
                    width: 50%;
                    height: 160px;
                    background: linear-gradient( 137deg, #13A88F 0%, rgba(19,168,143,0.2) 100%);
                    border-radius: 16px 16px 16px 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    
                }
            }
            .contentBottom{
                display: flex;
                margin-top: 16px;
                .contentBottomLeft{
                    width: 50%;
                    height: 160px;
                    margin-right: 16px;
                    background: linear-gradient( 153deg, #CCECE7 0%, #FFFFFF 100%);
                    border-radius: 16px 16px 16px 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    
                }
                .contentBottomRight{
                    width: 50%;
                    height: 160px;
                    background: linear-gradient( 153deg, #CCECE7 0%, #FFFFFF 100%);
                    border-radius: 16px 16px 16px 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                   
                }
            }
            
        }
       
        
    }

    
    </style>